$(document).ready(function(){
  $('.pet-selector .grid-items').click(function() {
    $('.pet-selector .grid-items').removeClass('selected');
    $(this).addClass('selected');
    $('.custom-atc-error').hide().text('');
    var starterID          = $(this).data('variant-starter');
    var fsID               = $(this).data('variant-founder-standard');
    var fpID               = $(this).data('variant-founder-premier');
    var singlediscount     = $('.subscribe-container').data('single_discount');
    var doublediscount     = $('.subscribe-container').data('double_discount');
    var tryoncediscount    = $('.subscribe-container').data('tryonce_discount');

    function getVariantData(id) {
      return window.productVariants.find(v => v.id == id);
    }

    var starterVar = getVariantData(starterID);
    var fsVar      = getVariantData(fsID);
    var fpVar      = getVariantData(fpID);

    if (starterVar) {
      
      if (tryoncediscount > 0) {
       
        var discount = (tryoncediscount * starterVar.price) / 100;
        var discountprice = starterVar.price - discount;
         $('.starter-price').text(Shopify.formatMoney(discountprice));
        $('.starter-compare').text(Shopify.formatMoney(starterVar.price)).show();
         $('.starter-compare').show();
      } else {
        $('.starter-price').text(Shopify.formatMoney(starterVar.price));
        $('.starter-compare').hide();
      }
    }

    if (fsVar) {
      if (singlediscount > 0) {
          var discount = (singlediscount * fsVar.price) / 100;
          var discountprice = fsVar.price - discount;
          $('.fs-price').text(Shopify.formatMoney(discountprice));
          $('.fs-compare').text(Shopify.formatMoney(fsVar.price)).show();
           $('.fs-compare').show();
      } else {
          $('.fs-price').text(Shopify.formatMoney(fsVar.price));
          $('.fs-compare').hide();
      }
    }

    if (fpVar) {
      var mainprice = (fpVar.price * 3);
      if (doublediscount > 0) {
          
          var discount = (doublediscount * mainprice) / 100;
          var discountprice = mainprice - discount;
          $('.fp-price').text(Shopify.formatMoney(discountprice));
          $('.fp-compare').text(Shopify.formatMoney(mainprice)).show();
           $('.fp-compare').show();
      } else {
          $('.fp-price').text(Shopify.formatMoney(mainprice));
          $('.fp-compare').hide();
      } 
    }

     function getSellingPlanID(variant) {
        if (!variant || !variant.selling_plan_allocations || variant.selling_plan_allocations.length === 0)
          return "";
        return variant.selling_plan_allocations[0].selling_plan_id ||
              variant.selling_plan_allocations[0].selling_plan.id;
      }

      var starterSP = getSellingPlanID(starterVar);
      var fsSP      = getSellingPlanID(fsVar);
      var fpSP      = getSellingPlanID(fpVar);

      // Update radio inputs dynamically
      $('input[data-plan="starter"]').attr("data-sellid", starterSP);
      $('input[data-plan="founder-standard"]').attr("data-sellid", fsSP);
      $('input[data-plan="founder-premier"]').attr("data-sellid", fpSP);
  }); 
});

$(document).ready(function() {
  var $atcBtn           = $('.custom-add-to-cart');
  var $subscribeContain = $('.subscribe-container');
  var $petSelector      = $('.pet-selector');
  var $pageContainer    = $('#PageContainer');
  var $errorBox         = $('.custom-atc-error');

  if (!$atcBtn.length) return;

  var cartType   = $pageContainer.data('cart-type');
  var cartAction = $pageContainer.data('cart-action');

  function showError(msg) {
    if ($errorBox.length) {
      $errorBox.text(msg).stop(true, true).fadeIn();
    } else {
      alert(msg);
    }
  }
  function showErrorPet(msg) {
    if ($errorBox.length) {
      $('.custom-atc-error-pet').text(msg).stop(true, true).fadeIn();
    } else {
      alert(msg);
    }
  }

  function clearError() {
    if ($errorBox.length) {
      $errorBox.stop(true, true).hide().text('');
      $('.custom-atc-error-pet').hide().text('');
    }
  }

  function setLoading(isLoading) {
    if (isLoading) {
      $atcBtn.addClass('is-loading');
      if (!$atcBtn.data('originalText')) {
        $atcBtn.data('originalText', $atcBtn.text().trim());
      }
      $atcBtn.text('Adding...');
      $atcBtn.attr('aria-busy', 'true');
    } else {
      $atcBtn.removeClass('is-loading');
      if ($atcBtn.data('originalText')) {
        $atcBtn.text($atcBtn.data('originalText'));
      }
      $atcBtn.attr('aria-busy', 'false');
    }
  }

  function updateCartCount() {
    if (!window.wetheme || !window.routes || !window.routes.cart_url) return;
    $.getJSON(window.routes.cart_url + '?view=compare').done(function(cart) {
      if (window.wetheme.updateCartCount) {
        window.wetheme.updateCartCount(cart);
      }
    });
  }

  $atcBtn.on('click', function() {
    if ($atcBtn.hasClass('is-disabled')) return;

    clearError();

    var $selectedDelivery = $subscribeContain.find('input[name="Delivery"]:checked');
    if (!$selectedDelivery.length) {
      showError('Please choose a delivery option.');
      return;
    }

    var planKey       = $selectedDelivery.attr('data-plan');     // starter / founder-standard / founder-premier
    var sellingPlanId = $selectedDelivery.attr('data-sellid');
    var isSubscription = typeof sellingPlanId !== 'undefined' && sellingPlanId !== '' && sellingPlanId !== null;

    var $selectedPet = $petSelector.find('.grid-items.selected');

    if (planKey === 'starter') {
      if (!$selectedPet.length) {
        $selectedPet = $petSelector.find('.grid-items').first();
        $selectedPet.addClass('selected');
      }
    } else {
      if (!$selectedPet.length) {
        showErrorPet('Please select your pet.');

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".variant--container-pet").offset().top -200
        }, 500);

        return;
      }
    }

    var variantDataKey = 'variant-' + planKey;
    var variantId = $selectedPet.data(variantDataKey);
    if (!variantId) {
      showError('This pet option is not available for the selected plan.');
      return;
    }

    var qty = 1;

    var sachetCount = Number($selectedPet.data('sachet_count')) || 1;

    var petHeading   = $.trim($selectedPet.find('.heading').text());
    var petText      = $.trim($selectedPet.find('.text').text());

    var petType = 'Dog';
    if (petHeading.toLowerCase().indexOf('cat') !== -1) {
      petType = 'Cat';
    }

    var petWeight = petType === 'Cat' ? 'Any' : petText;
    var subscriptionInterval = petType === 'Cat' ? '110' : '60';

    var subscriptionPlan = 'none';
    if (isSubscription) {
      if (planKey === 'founder-standard') subscriptionPlan = 'founder_standard';
      if (planKey === 'founder-premier')  subscriptionPlan = 'founder_premier';
    }

    var variantSku = '';
    if (window.productVariants && Array.isArray(window.productVariants)) {
      var v = window.productVariants.find(function(v) { return v.id == variantId; });
      if (v) variantSku = v.sku || '';
    }

    var includeCanisterFirst = subscriptionPlan !== 'none';

    var mdPayload = {
      petType: petType,
      petWeight: petWeight,
      sachetCount: sachetCount,
      sku: variantSku,
      subscriptionInterval: subscriptionInterval 
    };

    setLoading(true);

    var payload = {
      items: [{
        id: Number(variantId),
        quantity: qty,
        properties: {
          _md_payload: JSON.stringify(mdPayload)
        }
      }]
    };

    if (isSubscription) {
      payload.items[0].selling_plan = Number(sellingPlanId);
    }

    if (cartType === 'drawer') {
      payload.sections = 'cart-drawer';
    }

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    $.ajax({
      url: addUrl,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(payload),
      contentType: 'application/json',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: function(responseJson) {
        clearError();
        if (cartType === 'drawer' && window.eventBus) {
          if (window.eventBus.emit) {
            eventBus.emit('update:cart:drawer', responseJson);
            eventBus.emit('open:cart:drawer', { scrollToTop: true });
          }
          updateCartCount();
        } else {
          if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          } else {
            window.location = '/cart';
          }
        }
      },
      error: function(xhr) {
        var msg = 'Something went wrong. Please try again.';
        try {
          var response = JSON.parse(xhr.responseText);
          if (response.errors) msg = response.errors;
        } catch (e) {}

        showError(msg);

        if (xhr.status === 422 || /sold out/i.test(msg)) {
          // $atcBtn
          //   .addClass('is-disabled')
          //   .prop('disabled', true)
          //   .attr('aria-disabled', 'true');
        }

        setLoading(false);
      },
      complete: function() {
        setLoading(false);
      }
    });
  });

});
